import type { ReactNode } from "react";

import brocolyMark from "./brocoly-mark.png";
import { cn } from "./cn";

/**
 * The Brocoly broccoli: the same drawing as the old portal and the app's Plan tab.
 * `tile` sets it on a white tile, so it stays clear on the green sign-in panel.
 */
export function LogoMark({ className, tile = false }: { className?: string; tile?: boolean }) {
  if (!tile) {
    return (
      <img src={brocolyMark} alt="" width={36} height={36} className={cn("size-9 shrink-0", className)} />
    );
  }
  return (
    <span
      className={cn("flex size-12 shrink-0 items-center justify-center rounded-[14px] bg-white", className)}
    >
      <img src={brocolyMark} alt="" width={36} height={36} className="size-[72%]" />
    </span>
  );
}

/** `badge` sits beside the subtitle (e.g. the environment), so a narrow sidebar header keeps room. */
export function Logo({ subtitle, badge }: { subtitle?: string; badge?: ReactNode }) {
  return (
    <div className="flex items-center gap-2.5">
      <LogoMark />
      <div className="flex flex-col leading-tight">
        <span className="text-[17px] font-extrabold tracking-tight">Brocoly</span>
        {(subtitle || badge) && (
          <span className="flex items-center gap-1.5 text-xs font-medium text-muted">
            {subtitle}
            {badge}
          </span>
        )}
      </div>
    </div>
  );
}
